import {
    Cart,
    invalidAddressException,
    updateCart,
    UpdateCartApiParameter,
} from "@dana/Overrides/Services/CartService";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import { getCookie } from "@insite/client-framework/Common/Cookies";
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { CarrierDto, ShipViaDto } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        carrier: CarrierDto;
        shipVia?: ShipViaDto;
    },
    UpdateCartApiParameter
>;

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState() as ApplicationStateDana;
    const cartMode = getCookie('cartMode');
    const { cartId } = state.pages.onePageCheckout;
    let cart: Cart | undefined;
    if (cartMode === 'StockOrderCart') {
        cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value
    } else if (cartMode === 'EmergencyOrderCart') {
        cart = state.emergencyCartState.cart as Cart;
    } else {
        cart = state.annualReturnsCartState.cart as Cart;
    }
    if (!cart) {
        throw new Error("There was no current cart and we are trying to set a shipping method on it.");
    }

    const updatedCart: Cart = {
        ...cart,
        ...props.parameter,
    };
    props.apiParameter = { cart: updatedCart };
};

export const UpdateCart: HandlerType = async props => {
    try {
        await updateCart(props.apiParameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400 && error.errorJson.message === invalidAddressException) {
            props.dispatch({
                type: "Components/AddressErrorModal/SetIsOpen",
                isOpen: true,
            });
            return false;
        }
        throw error;
    }
};

export const LoadCart: HandlerType = props => {
    const state = props.getState();
    const { cartId } = state.pages.onePageCheckout;
    if (cartId) {
        props.dispatch(loadCart({ cartId, getPromotions: true }));
    } else {
        props.dispatch(loadCurrentCart({ getPromotions: true }));
    }
};

export const chain = [PopulateApiParameter, UpdateCart, LoadCart];

const setShippingMethod = createHandlerChainRunner(chain, "SetShippingMethod");
export default setShippingMethod;
